import { render, staticRenderFns } from "./VerifyPersonal.vue?vue&type=template&id=1995da9b"
import script from "./VerifyPersonal.vue?vue&type=script&lang=js"
export * from "./VerifyPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports